__turbopack_context__.v({
  "container": "QZzePG_container",
  "inner": "QZzePG_inner",
  "isOpen": "QZzePG_isOpen",
  "outer": "QZzePG_outer",
  "placement--left": "QZzePG_placement--left",
  "placement--right": "QZzePG_placement--right",
  "variant--clipboard": "QZzePG_variant--clipboard",
  "variant--filters": "QZzePG_variant--filters",
  "variant--nav": "QZzePG_variant--nav",
});
